import { create } from 'zustand';

export interface Breadcrumb {
  id: string | null;
  translationKey: string | null;
  path: string;
}

type BreadcrumbsState = {
  breadcrumbs: Breadcrumb[];
  idToTextMap: Record<string, string>;
  setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => void;
  updateIdToTextMap: (id: string, text: string) => void;
};

export const useBreadcrumbsStore = create<BreadcrumbsState>((set) => ({
  breadcrumbs: [],
  idToTextMap: {},
  setBreadcrumbs: (breadcrumbs) => set({ breadcrumbs }),
  updateIdToTextMap: (id: string, text: string) =>
    set((state) => ({
      idToTextMap: { ...state.idToTextMap, [id]: text },
    })),
}));
